import { getURLParams } from "src/utils/urlParams";

const SMARTDOSE_REFILL_UTM_SOURCE = "smartdose_refill";
const INTERNAL_DRUG_ID_PARAM = "internal_drug_id";
const SCHEDULED_FILL_ID_PARAM = "scheduled_fill_id";

function paramValue(params: Record<string, string>, key: string) {
  const value = params[key];
  return typeof value === "string" ? value : "";
}

/**
 * True when the visit came from the in-app SmartDose refill screen.
 * Pagesets use this to show only confirm order.
 */
export function isSmartDoseRefillDeeplink() {
  const params = getURLParams();
  return (
    paramValue(params, "utm_source") === SMARTDOSE_REFILL_UTM_SOURCE &&
    paramValue(params, INTERNAL_DRUG_ID_PARAM).length > 0 &&
    paramValue(params, SCHEDULED_FILL_ID_PARAM).length > 0
  );
}

export function readSmartDoseRefillSelection() {
  const params = getURLParams();
  const selectedInternalDrugId = paramValue(params, INTERNAL_DRUG_ID_PARAM);
  const scheduledFillId = Number(paramValue(params, SCHEDULED_FILL_ID_PARAM));
  if (!selectedInternalDrugId) {
    return null;
  }
  if (!Number.isInteger(scheduledFillId) || scheduledFillId <= 0) {
    return null;
  }
  return { selectedInternalDrugId, scheduledFillId };
}
